//
//
//
//
//
//
//
//

import { mapState } from "vuex";
import dayjs from "dayjs";
export default {
  props: {
    active: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapState(["dateList"]),
    formatTime() {
      return this.dateList
        ? dayjs(this.dateList[this.active]).format("YYYY年MM月")
        : "";
    },
  },
  watch: {
    dateList() {
      this.$emit("update:active", 2);
    },
  },
  methods: {
    onChange(active) {
      if (active < 0 || active > 2) return;
      this.$emit("update:active", active);
    },
  },
};
